import { useStore } from "@roc/client-portal-shared/hooks";
import { observer } from "mobx-react";
import ComparablesFeedback from "./comparablesFeedback";
import { StandardDialog } from "@roc/ui";
import { useEffect, useState } from "react";
import { PropertyComparableFeedbackRequest } from "../types/propertyTypes";
import { formatCurrencyField } from "@roc/feature-valuation-review-v2";


export type ComparablesFeedbackModalProps = {
  open?: boolean;
  onClose?: () => void;
  onSaveComplete: () => void;
}
const safeString = (value: any) => (value === null || value === undefined ? "-" : value);
const mapPropertyToRow = (property, selectedIds: Set<string>, index) => {
  const firstImage = property.data.images?.[0]?.url || "";

  const rooms = property.data?.rooms ?? "-";
  const bedrooms = property.data?.bedrooms ?? "-";
  const bathrooms = property.data?.full_bathrooms ?? "-";

  return {
    property_id: property.property_id,
    imageUrl: firstImage,
    selected: selectedIds.has(property.property_id),
    address: safeString(property.data.address),
    mls_number: safeString(property.data.mls_number),
    price: formatCurrencyField(property.data.price),
    proximity: safeString(property.data.proximity),
    dom: safeString(property.data.dom),
    roomsBedroomsBathrooms: `${rooms} Rm / ${bedrooms} Br / ${bathrooms} Ba`,
    sqft_price: formatCurrencyField(property.data.sqft_price),
    reason: "",
    comparableNumber: index + 1,
  }
};

export const ComparablesFeedbackModal = observer((props: ComparablesFeedbackModalProps) => {
  const { open, onClose, onSaveComplete } = props;
  const { compToolStoreV2: compToolStore } = useStore();
  const selectedIds = new Set(compToolStore.selectedCompareProperties.map(c => c.property_id));

  const comparablesData = compToolStore.firstThreeProperties
    .map((property, index) => mapPropertyToRow(property, selectedIds, index))

  const [comparables, setComparables] = useState([]);

  useEffect(() => {
    setComparables(comparablesData)
  }, [open]);

  const onReasonChange = (propertyId: number, reason: string) => {
    setComparables((prev) => {
      return prev.map((item) => item.property_id === propertyId ? { ...item, reason } : item);
    });
  };

  const onApplyFeedback = async () => {
    const requestBody: PropertyComparableFeedbackRequest[] = comparables
      .filter((c) => !c.selected && c.reason)
      .map((c) => ({
        propertyId: compToolStore.loanInformation.property_id,
        loanId: compToolStore.loanInformation.loan_id,
        subjectPropertyId: compToolStore.subjectProperty.property_id,
        rejectedPropertyId: c.property_id,
        comparableNumber: c.comparableNumber,
        reason: c.reason
      }));

    try {
      const result = await compToolStore.savePropertyComparableFeedback(requestBody);
      if (result)
        onSaveComplete();
    } catch (err) {
      console.error("Failed to save feedback.", err);
    }
  };

  const onOmitFeedback = () => {
    onSaveComplete();
  }

  const dialogContent = (
    <>
      <ComparablesFeedback
        comparables={comparables}
        onReasonChange={onReasonChange}
        onApplyFeedback={onApplyFeedback}
        onOmitFeedback={onOmitFeedback} />
    </>
  );

  return (
    <StandardDialog
      open={open}
      title={"Add Comparables To Loan - Comparables Algorithm Feedback"}
      maxWidth="md"
      onClose={onClose}
      handleClose={onClose}
      dialogContent={dialogContent}
      removeContentBox={true}
    />
  );
})